"use strict";

var LoggerInstance = require("js-logger").get("SponsorshipSearchHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var SponsorshipApi = require("../api/SponsorshipApi");

var HistoryHelper = require("../shared/HistoryHelper");
var InputHelper = require("../shared/InputHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var QueryStringHelper = require("../shared/QueryStringHelper");

var GridListToggleHelper = require("../designer/components/searchResults/GridListToggleHelper");

var SponsorshipSearchHelper = {
	initializeSponsorshipSearchForm: function(isDesignMode, $component, layoutName, isIncorrectSearchId) {
		//Setting the listener on the submit button
		var $sponsorshipSearchFormComponents = $($component || "[data-component='sponsorshipSearchForm']");
		$sponsorshipSearchFormComponents.each((index, element) => {
			// We were passing in sponsorshipSearchOtherForm, but we don't currently support other sponsorships. Chris R. confirmed we can remove it from this find.
			var $form = $(element).find("form#sponsorshipSearchChildForm").first();
			$form.off("submit.sponsorshipSearchForm");
			$form.on("submit.sponsorshipSearchForm", this._submitSponsorshipSearchForm.bind(this, isDesignMode));
		});

		if (!isDesignMode) {
			this.layoutName = layoutName;

			//This is used to let the HistoryHelper know when to add state or push state.  If the id is the same as passed in last time, we replace the state.
			//	Each time a new action occurs (search, paging, etc.), the state should be pushed.
			window.lastUpdateId = 0;
			//Seeing if we have any criteria in the query string
			var query = window.location.search;
			if (query) {
				query = query.substring(1);
				var currentQueryObject = QueryStringHelper.createObjectFromQueryString(query) || {};

				var foundInput = this._updateSearchFormFields(currentQueryObject, $sponsorshipSearchFormComponents);

				if (foundInput) {
					var $firstSearchForm = $sponsorshipSearchFormComponents.first();

					if (!currentQueryObject.id && !currentQueryObject.c) {
						//Only search if do not have an Id.  Otherwise, we probably already did the search before the page loaded.
						this._performSponsorshipSearchFromSearchForm($firstSearchForm);
					} else if (isIncorrectSearchId) {
						//An Id was incorrect when trying to run the search on the server, remove the Ids, keep the criteria and try the search again
						isIncorrectSearchId = false;
						var criteria = this._getCriteria($firstSearchForm);
						this._resetSearch(criteria);
						this._performSponsorshipSearchFromSearchForm($firstSearchForm);
					}
				}
			}

			this.initializeSponsorshipSearchResultsButton(isDesignMode);
			this._initializeGridListToggle();

			window.onpopstate = (event) => {
				this._handlePopState(event);
			};
		}
	},

	initializeSponsorshipSearchResultsButton(isDesignMode, $component) {
		var $childSponsorship = ($component || $("body")).find("[data-component='sponsorshipSearchResults.child']")
		var $buttonElements = $childSponsorship.find("[data-component='sponsorshipSearchResults.button']");
		if (!isDesignMode) {
			//For the search button
			$buttonElements.off("mousedown.initializeResultsButton");
			$buttonElements.on("mousedown.initializeResultsButton", (event) => {
				this.mouseDownId = $(event.target).attr("id");
				if (event && event.which === 2) {
					//Making it so middle click does not try to allow the user to scroll
					return false;
				}
			});
			$buttonElements.off("mouseup.initializeResultsButton");
			$buttonElements.on("mouseup.initializeResultsButton", (event) => {
				var $element = $(event.target);
				if (this.mouseDownId === $element.attr("id")) {
					this._navigateToTangible(false, event);
				}
				this.mouseDownId = null;
			});
			$("body").off("mouseup.initializeResultsButton");
			$("body").on("mouseup.initializeResultsButton", () => {
				this.mouseDownId = null;
			});

			//For text and image anchor links
			var linkElements = $childSponsorship.find("[data-dynamic-href='sponsor-a-child']");
			linkElements.off("click.initializeResultsButton");
			linkElements.on("click.initializeResultsButton", (event) => {
				this._navigateToTangible(false, event);
				if (event.which === 1) {
					//Only prevent default, etc. if left-clicking.  Otherwise, let it do what it normally does, most likely open a new tab.
					event.preventDefault();
					event.stopPropagation();
					return false;
				}
			});
		} else {
			$buttonElements.off("click.initializeResultsButton");
			$buttonElements.on("click.initializeResultsButton", (event) => {
				this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("sponsor-a-child"), isDesignMode);
			});
		}
	},

	performSponsorshipSearch: function(sponsorshipSearchResultsId, pageNumber, sponsorshipType, criteria, additionalOptions) {
		var currentUpdateId = lastUpdateId + 1;
		additionalOptions = additionalOptions || {};
		var $sponsorshipSearchResultsComponents = $("[data-component='sponsorshipSearchResults']");
		if (sponsorshipSearchResultsId) {
			$sponsorshipSearchResultsComponents = $sponsorshipSearchResultsComponents.filter(`#${sponsorshipSearchResultsId}`);
		}
		//If there is no criteria, we might be paging, make sure we have it so that the browser history and query strings are updated appropriately.
		criteria = criteria || this._getCriteria($("[data-component='sponsorshipSearchForm']").first());

		var isInitialSearch = !sponsorshipSearchResultsId && !pageNumber && (!additionalOptions || additionalOptions.isInitialSearch !== false);

		$sponsorshipSearchResultsComponents.each((index, sponsorshipSearchResultsComponent) => {
			var $sponsorshipSearchResultsComponent = $(sponsorshipSearchResultsComponent);
			sponsorshipSearchResultsId = $sponsorshipSearchResultsComponent.attr("id");
			var additionalSearchOptions = additionalOptions[sponsorshipSearchResultsId] || {};
			var databaseSearchId = !isInitialSearch ? (additionalSearchOptions.id ? additionalSearchOptions.searchId : $sponsorshipSearchResultsComponent.find("[data-component='sponsorshipSearchResults.populated']").attr("data-search-id")) : undefined;
			var limit = $sponsorshipSearchResultsComponent.attr("data-limit");
			var offset = additionalSearchOptions.offset ? additionalSearchOptions.offset : (pageNumber ? (limit * (pageNumber - 1)) : undefined);
			var gridOrListSelected = $sponsorshipSearchResultsComponent.attr("data-selected-results-view");
			if (!sponsorshipType) {
				sponsorshipType = $sponsorshipSearchResultsComponent.find("[data-component='sponsorshipSearchResults.child']").length ? "CHILD" : "OTHER";
			}

			SponsorshipApi.search({
				criteria: criteria,
				id: sponsorshipSearchResultsId,
				layoutId: window.layoutId,
				layoutName: this.layoutName,
				limit: limit,
				offset: offset,
				searchId: databaseSearchId,
				sponsorshipType
			}).done((data) => {
				// Unmount existing react components on paging after the search so we do not get that disappearing React component issue.
				$sponsorshipSearchResultsComponent.find("[data-react-component-name]").each(function() {
					ReactDOM.unmountComponentAtNode(this.parentElement);
				});

				//Set new sponsorshipSearchResultsComponent
				var $data = $(data);
				$sponsorshipSearchResultsComponent.html($data);

				this.initializeSponsorshipSearchResultsButton(/*isDesignMode*/false);
				this._initializeGridListToggle(sponsorshipSearchResultsId, gridOrListSelected);

				//Get the new searchId (in the case this is the first search)
				//	null will remove searchId from the query string if there were no results found.
				databaseSearchId = $sponsorshipSearchResultsComponent.find("[data-component='sponsorshipSearchResults.populated']").attr("data-search-id") || null;

				if (!additionalOptions.doNotPushState) {
					//Saving History state if we need to do so
					var searchObject = Object.assign({
						id: sponsorshipSearchResultsId,
						searchId: databaseSearchId
					});

					if (pageNumber) {
						searchObject.offset = offset;
					} else {
						//We should clear the offset
						//	Undefined won't work as those are removed before the Object.assign
						//	We specifically need null because in the Object.assign it will replace the old offset, and then null values are removed before creating the query string
						searchObject.offset = null;
					}
					this._updateHistoryStateAfterSearch(criteria, searchObject, currentUpdateId);
				}

				if (sponsorshipSearchResultsId) {
					// Scroll to top of component which was paged
					var $newSponsorshipSearchResultsComponent = $(`#${sponsorshipSearchResultsId}`);
					var $window = $(window);
					var top = $newSponsorshipSearchResultsComponent.offset().top;
					var distanceToTop = top - $window.scrollTop();
					if (distanceToTop < 0 || distanceToTop > $window.height()) {
						$("html, body").animate({ scrollTop: top }, 200);
					}
				}
			}).fail((jqXHR, textStatus, errorThrown) => {
				if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message === "Partial Invalid") {
					this._resetSearch(criteria);

					//Since we didn't find the right sponsorshipSearchResults Id, let's go ahead and refresh the page, removing the id query string
					window.location.reload();
				}
			});
		});
	},

	_getCriteria: function ($target) {
		// We were passing in sponsorshipSearchOtherForm, but we don't currently support other sponsorships. Chris R. confirmed we can remove it from this find.
		var $namedInputs = $target.find("form#sponsorshipSearchChildForm").first().find("input[name],select[name]");
		var criteria = InputHelper.getGeneralInputValues($namedInputs) || [];

		//Removing the blank/empty values.
		var inputData;
		for (var index = criteria.length - 1; index >= 0; --index) {
			inputData = criteria[index] || {};
			if (!inputData.value) {
				criteria.splice(index, 1);
			}
		}

		return criteria;
	},

	_getEventOrReturn: function (event, isDesignModeMessage, isDesignMode) {
		return ActionsHelper.getEventOrReturn(event, isDesignMode != null ? isDesignMode : false, isDesignModeMessage, /*preventDefaultInDesignMode*/false); //coersion, because we want to check for null or undefined
	},

	_handlePopState: function (event) {
		HistoryHelper.handlePopState(/*executeAction*/(currentQueryObject, additionalOptions) => {
			//Set input/selects correctly on sponsorshipSearchForm
			//Only expecting a single sponsorshipSearchForm on the page.
			var $sponsorshipSearchForms = $("[data-component='sponsorshipSearchForm']");
			this._updateSearchFormFields(currentQueryObject, $sponsorshipSearchForms);

			//Search (as if the search button was clicked, just find the first form)
			var $firstSearchForm = $sponsorshipSearchForms.first();
			var criteria = this._getCriteria($firstSearchForm);
			var sponsorshipType = $firstSearchForm.find("[data-component='sponsorshipSearchForm.child']").length ? "CHILD" : "OTHER";
			additionalOptions.isInitialSearch = false;
			this.performSponsorshipSearch(/*sponsorshipSearchResultsId*/null, /*pageNumber*/null, sponsorshipType, criteria, additionalOptions);
		}, /*shouldShortCircuit*/(currentQueryObject) => {
			//If there is no query string do not perform the sponsorshipSearch
			return Object.keys(currentQueryObject).length === 0;
		});
	},

	_initializeGridListToggle: function(id, previouslySelectedView) {
		GridListToggleHelper.initializeGridListToggle(id, previouslySelectedView, "sponsorshipSearchResults", "grid-sponsorship-search-results-wrapper", "list-sponsorship-search-results-wrapper");
	},

	_navigateToTangible: function(isDesignMode, event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("sponsor-a-child"), isDesignMode);
		if (!event) {
			return;
		}

		var $element = $(event.target);
		//Make sure we have a button or anchor
		if (!$element.is("button") && !$element.is("a")) {
			$element = $element.closest("button,a");
		}

		if (event.which === 1) {
			//Left-click, is the only one where we check to see if this sponsorship is available
			var sponsorshipCode = $element.closest("[data-component='sponsorshipSearchResults.child']").attr("data-sponsorship-code");
			if (!sponsorshipCode) {
				//We do not have a sponsorshipCode, but we should have
				LoggerInstance.error("There was no sponsorship code when there should have been.");
				return;
			}

			SponsorshipApi.isAvailableForSponsorship({sponsorshipCode}).done(data => {
				data = data || {};
				var isAvailableForSponsorship = (data.model || {}).isAvailableForSponsorship;

				window.PledgeActions.setSponsorshipAvailablity(isAvailableForSponsorship);
				if (isAvailableForSponsorship) {
					//It is available for sponsorship, so go ahead and navigate to the detail page
					window.location = $element.attr("data-url") || $element.attr("href");
				} else {
					//The sponsorship is not available, so show the alert and do not navigate
					window.PledgeActions.showSponsorshipNotAvailableMessage();
				}
			}).fail(() => {
				//The sponsorship is not available, so show the alert and do not navigate
				window.PledgeActions.setSponsorshipAvailablity(false);
				window.PledgeActions.showSponsorshipNotAvailableMessage();
			});

			event.preventDefault();
			event.stopPropagation();
		} else if (event.which === 2) {
			if ($element.is("button")) {
				//Middle-click, for buttons we need to manually open the new tab.
				window.open($element.attr("data-url") || $element.attr("href"), "_blank");
			}
		}

		//For right-click or any other click we don't want to do anything ourselves; we just want to let the context menu appear like it normally does.
	},

	_performSponsorshipSearchFromSearchForm: function($sponsorshipSearchForm) {
		var sponsorshipType = $sponsorshipSearchForm.find("[data-component='sponsorshipSearchForm.child']").length ? "CHILD" : "OTHER";
		var criteria = this._getCriteria($sponsorshipSearchForm);
		this.performSponsorshipSearch(/*sponsorshipSearchResultsId*/null, /*pageNumber*/null, sponsorshipType, criteria);
	},

	_resetSearch: function(criteria) {
		var criteriaForQueryString = this._transformCriteriaForQueryString(criteria);

		HistoryHelper.replaceHistoryState(criteriaForQueryString);
	},

	_submitSponsorshipSearchForm: function(isDesignMode, event) {
		event = this._getEventOrReturn(event, "Sponsorship Search Form action called successfully.", isDesignMode);
		if (!event) {
			return;
		}

		var $sponsorshipSearchForm = $(event.target).closest("[data-component='sponsorshipSearchForm']");
		this._performSponsorshipSearchFromSearchForm($sponsorshipSearchForm);
	},

	_transformCriteriaForQueryString: function(criteria) {
		//This will take a query string object that is received from the searchForm and convert it to the format that is used in the query string.
		var criteriaForQueryString = {};
		if (criteria && criteria.length) {
			criteria.forEach(criterion => {
				criteriaForQueryString[`c_${criterion.type}`] = criterion.value;
			});
		}

		return criteriaForQueryString;
	},

	_updateHistoryStateAfterSearch: function (criteria, newQueryObject, updateId) {
		var criteriaForQueryString = this._transformCriteriaForQueryString(criteria);

		HistoryHelper.updateHistoryStateAfterLoad(newQueryObject, updateId, /*afterCreateObjectLogic*/(currentQueryObject) => {
			//Clear criteria from currentQueryObject
			Object.keys(currentQueryObject).forEach(key => {
				if (key && key.startsWith("c_")) {
					delete currentQueryObject[key];
				}
			});

			if (criteria && criteria.length) {
				Object.assign(currentQueryObject, criteriaForQueryString);
			}
		});
	},

	_updateSearchFormFields: function(currentQueryObject, $sponsorshipSearchFormComponents) {
		var foundInput = false;

		//Reset values
		$sponsorshipSearchFormComponents.find("input").prop("checked", false);
		$sponsorshipSearchFormComponents.find("select").val("");

		//Populating criteria input/select fields
		Object.keys(currentQueryObject).forEach(key => {
			var value = currentQueryObject[key];

			if (!key || !key.startsWith("c_")) {
				return;
			}

			//The actual input field does not have c_ in it.
			key = key.replace("c_", "");

			//Radio Buttons and Single Checkbox
			var $matchingFields = $sponsorshipSearchFormComponents.find(`input[name="${key}"][value="${value}"],[data-component='singleCheckbox'][code-type="${key}"][code-type-true-value="${value}"] input`);//,`);
			if ($matchingFields.length) {
				$matchingFields.prop("checked", true);
				foundInput = true;
			} else {
				//Select
				$matchingFields = $sponsorshipSearchFormComponents.find(`select[name="${key}"]`);
				if ($matchingFields.length) {
					$matchingFields.val(value);
					foundInput = true;
				}
			}
		});

		return foundInput;
	}
};

module.exports = SponsorshipSearchHelper;
